import { l } from 'client/Other/Translation'
import * as React from 'react'

import { setBaseClass } from '../../../utils'
import './Toggle.scss'

const cls = setBaseClass('ZervantToggle')

export class Toggle extends React.Component<{
  onChange?: (value: boolean) => void
  value: boolean
  automation?: string
  disabled?: boolean
  labels?: {
    on: string
    off: string
  }
}> {
  private toggle() {
    if (!this.props.disabled) {
      this.props.onChange(!this.props.value)
    }
  }

  public render() {
    const isOn = this.props.value
    const textOn = (this.props.labels && this.props.labels.on) || l('ui.toggle.on')
    const textOff = (this.props.labels && this.props.labels.off) || l('ui.toggle.off')
    const text = isOn ? textOn : textOff

    return (
      <div className={cls()}>
        <div
          onClick={() => this.toggle()}
          data-automation={this.props.automation}
          className={cls({
            __container: true,
            '--disabled': this.props.disabled,
            '__container--on': isOn,
            '__container--off': !isOn,
          })}
        >
          <span>{text}</span>
          <i />
        </div>
      </div>
    )
  }
}
